import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'gray' | 'green' | 'yellow' | 'red' | 'blue';

const toneClass: Record<Tone, string> = {
  gray: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
  green: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200',
  yellow: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200',
  red: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-200',
  blue: 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-200',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

export function Badge({ tone = 'gray', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        toneClass[tone],
        className,
      )}
      {...rest}
    />
  );
}
